/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState, useContext, Dispatch, SetStateAction, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import { SupplierFilters, VehiclesFilters } from '@types'

type ContextState = {
  filters: VehiclesFilters
  setFilters: Dispatch<SetStateAction<VehiclesFilters>>
  isSuppliersSync: boolean
  setIsSuppliersSync: Dispatch<SetStateAction<boolean>>
  resetFilters: () => void
  resetTriggered: number
}

export const initialSuppliersFiltersState: ContextState = {
  filters: { page: 1, limit: 10, orderBy: 'ASC' },
  setFilters: () => {},
  isSuppliersSync: false,
  setIsSuppliersSync: () => {},
  resetFilters: () => {},
  resetTriggered: 0,
}

const SuppliersContext = React.createContext<ContextState>(initialSuppliersFiltersState)

type SuppliersFiltersProviderProps = {
  children: React.ReactNode
}

export function SuppliersFiltersProvider({ children }: SuppliersFiltersProviderProps) {
  const [isSuppliersSync, setIsSuppliersSync] = useState<boolean>(false)
  const [filters, setFilters] = useState<SupplierFilters>(initialSuppliersFiltersState.filters)
  const [resetTriggered, setResetTriggered] = useState<number>(0)
  const [search] = useSearchParams()
  const resetFilters = () => {
    setResetTriggered(state => state + 1)
  }

  useEffect(() => {
    if (resetTriggered) {
      setFilters(initialSuppliersFiltersState.filters)
    }
  }, [resetTriggered])

  useEffect(() => {
    if (filters && search.get('service') && !filters.limit) {
      const timeout = setTimeout(
        () =>
          setFilters(state => ({
            ...state,
            asnum: Number(search.get('service')) ?? undefined,
            page: initialSuppliersFiltersState.filters.page,
          })),
        0,
      )

      return () => clearTimeout(timeout)
    } else {
      setFilters(initialSuppliersFiltersState.filters)
    }
  }, [search])

  return (
    <SuppliersContext.Provider
      value={{
        filters,
        setFilters,
        isSuppliersSync,
        setIsSuppliersSync,
        resetFilters,
        resetTriggered,
      }}
    >
      {children}
    </SuppliersContext.Provider>
  )
}

export function useSuppliersContext(): ContextState {
  const context = useContext(SuppliersContext)
  if (!context) throw Error('This hook can only be used under the VehicleFiltersProvider component')
  return context
}
